module.exports = __webpack_public_path__ + "static/15-1-b9aac44c8b756e9944239bfd4659319d.jpg";